import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { UriInterceptor } from './interceptor/uri.interceptor';
import { VersionInterceptor } from './interceptor/version.interceptor';
import { InterceptorService } from './interceptor/error.interceptor';
import { AuthenticationCallbackComponent } from './components/authentication-callback/authentication-callback.component';
import { UserService } from './services/user.service';
import { AuthenticationService } from './services/authentication.service';

@NgModule({
  declarations: [AuthenticationCallbackComponent],
  exports: [],
  imports: [CommonModule],
  providers: [
    UserService,
    AuthenticationService,
    { provide: HTTP_INTERCEPTORS, useClass: VersionInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: UriInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
  ],
})
export class CoreModule {}
